import { render, staticRenderFns } from "./StoreGiftListItemComponent.vue?vue&type=template&id=036f681e&scoped=true"
import script from "./StoreGiftListItemComponent.vue?vue&type=script&lang=js"
export * from "./StoreGiftListItemComponent.vue?vue&type=script&lang=js"
import style0 from "./StoreGiftListItemComponent.vue?vue&type=style&index=0&id=036f681e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036f681e",
  null
  
)

export default component.exports